(function (angular) {

    /**
     * 
     * @param $http {angular.IHttpService}
     * @param $q {angular.IPromise}
     * @param $Config {$Config}
     * @param $translationService {$translationService}
     * @param $message {$message}
     * @param $mdDialog {$mdDialog}
     * @constructor
     */
        function ChargeRequestService($http, $q, $Config, $translationService, $message, $mdDialog) {
            this.apiUrl = $Config.apiUrl;
            this.$http = $http;
            this.$q = $q;
            this.$translationService = $translationService;
            this.$message = $message;
            this.$mdDialog = $mdDialog;
        }

        ChargeRequestService.$inject = [ '$http', '$q', '$Config','$translationService', '$message', '$mdDialog'];

        ChargeRequestService.prototype.get = function (id) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.get(this.getUrl("mobile/ChargeRequest/get"),{ params: {Id: id} }).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        };

        ChargeRequestService.prototype.getUrl = function (url) {
            return this.apiUrl + url;
        };

        // Removed from NF-535
        // ChargeRequestService.prototype = {
        //     getUrl: function (url) {
        //         return this.apiUrl + url;
        //     },
        //     /**
        //      * Sample of dto return
        //      * {
        //             "ChargeRequest":
        //             "AvailableChargingPoints": false,
        //             "QueuedChargeRequestEnabled": false,
        //             "Vehicles": null,
        //             "DueChargeBookings": null,
        //             "CanChargeOnlyUsingTheRenewableEnergyProducedOnSite": false,
        //             "SolarOnlyModeAvailable": false
        //         }
        //      */
        //     getCurrentChargeRequest: function () {
        //         return this.$q(angular.bind(this, function (resolve, reject) {
        //             this.$http.get(this.getUrl("mobile/ChargeRequest/GetCurrentChargeRequest")).then(function (response) {
        //                 resolve(response.data);
        //             }, reject);
        //         }));
        //     }  
        // };
        
        ChargeRequestService.prototype.connect = function (data) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.post(this.getUrl("mobile/ChargeRequest/connect"), data).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        };
        ChargeRequestService.prototype.queueChargeRequest = function (data) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.post(this.getUrl("mobile/ChargeRequest/Queue"), data).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        };

        ChargeRequestService.prototype.deQueueChargeRequest = function (data) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.post(this.getUrl("mobile/ChargeRequest/Dequeue"), data).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        };

        ChargeRequestService.prototype.update = function (data) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.post(this.getUrl("mobile/ChargeRequest/update"), data).then(function (response) {                    
                    resolve(response.data);
                }, reject);
            }));
        };

        ChargeRequestService.prototype.disconnect = function (data) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.post(this.getUrl("mobile/ChargeRequest/disconnect"), data).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        };

        ChargeRequestService.prototype.getParkings = function (siteId) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                var p = { };

                if (siteId) {
                    p.siteid = siteId;
                }

                this.$http.get(this.getUrl("mobile/ChargeRequest/Parkings"), { params: p }).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        };

        ChargeRequestService.prototype.getChargingPoints = function (siteId, parkingId, includeExternal) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                var p = { };

                if (siteId) {
                    p.siteid = siteId;
                }

                if (parkingId) {
                    p.parkingid = parkingId;
                }

                if (includeExternal) {
                    p.includeExternal = 'true';
                }

                this.$http.get(this.getUrl("mobile/ChargeRequest/chargingpoints"), { params: p }).then( (response) => {
                    let items = response.data;
                    items.forEach( (item) => {
                        // item.State = 9; // test
                        if (item.UserName === '(occupied)') { // translate occupied
                            item.UserName = this.$translationService.getTranslation('Occupied');
                        }
                    });
                    resolve(items);
                }, reject);
            }));
        };

        ChargeRequestService.prototype.getAvailableChargingPoints = function (siteId) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.get(this.getUrl("mobile/ChargeRequest/CheckIfAvailableChargingPointsOnSite"), { params: { siteid: siteId, includeExternal: 'true' } }).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        };

        ChargeRequestService.prototype.getChargeBookingsDueToday  = function (siteId) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.get(this.getUrl("mobile/ChargeRequest/GetChargeBookingsDueToday")).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        };

        ChargeRequestService.prototype.markCharginPointAsFree  = function (requestId) {
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.post(this.getUrl("mobile/home/MarkChargingPointAsFreeForMostRecentCharge"), { Id: requestId}).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        };

        ChargeRequestService.prototype.reportChargingPointIssue = function(data){
            return this.$q(angular.bind(this, function (resolve, reject) {
                this.$http.post(this.getUrl("mobile/ChargeRequest/ReportChargingPointIssue"), data).then(function (response) {
                    resolve(response.data);
                }, reject);
            }));
        }


        ChargeRequestService.prototype.handleOdometerReadingError = function (error)  {
            let data = error.data;
            if (!data || !_.isObject(data))
                data = {};
            if (data.code === 'OdometerReadingSmallerThanPriorEntry' || data.code === 'OdometerReadingMuchGreaterThanPriorEntry') {
                return this.showOdometerReadingConfirmPopup(data).then((result) => {
                    if (result) {
                        return Promise.resolve(true);
                    } else {
                        return Promise.reject('User cancelled odometer reading confirmation.');
                    }
                });
            } else {
                return this.$message.error(error);
            }
        };
        
        /**
         * Show confirm dialog when OdometerReading not in range
         * @param {{code: string, message: string}} error
         * @returns {angular.IPromise<boolean>}
         */
        ChargeRequestService.prototype.showOdometerReadingConfirmPopup = function (error) {
            function DialogController($mdDialog, errorMessage) {
                this.$mdDialog = $mdDialog;
                this.errorMessage = errorMessage;
                this.item = {
                    BypassValidationOfOdometerReading: false
                };
            }
            DialogController.$inject = ['$mdDialog', 'errorMessage'];
            DialogController.prototype = {
                onBtnOkClicked() {
                    this.$mdDialog.hide(true);
                },
                onBtnCancelClicked() {
                    this.$mdDialog.hide(false);
                }
            }
            
            // Show Dialog
            return this.$mdDialog.show({
                controller: DialogController,
                controllerAs: 'vm',
                templateUrl: 'js/internal/chargingrequest/confirm-odometer-reading-modal.view.html',
                parent: angular.element(document.body),
                locals: {
                    errorMessage: this.$translationService.formatTranslation(error.code, error.message )
                },
                focusOnOpen: false
            })
        };


    angular.module('shared').service('ChargeRequestService',  ChargeRequestService);
}(angular));
